import { CellProps } from 'react-table'
import { AtendimentoReport } from '../../../../meus-atendimentos/meus-atendimentos-list/core/_models'
import { sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const relatorioColumns = (t: TFunction): ReadonlyArray<TableColumn<AtendimentoReport>> => [
  // Coluna do botão de expandir (o ModernTable desenha o botão na coluna de id `expand`).
  {
    Header: () => <span className='visually-hidden'>Detalhes</span>,
    id: 'expand',
    cellWidth: '56px',
  },
  // Paciente com o protocolo como apoio; os dois seguem ordenáveis.
  sortableColumn<AtendimentoReport>({
    id: 'paciente.pessoa.nome',
    useQueryRequest,
    fields: [
      { field: 'paciente.pessoa.nome', label: t('cols.paciente') },
      { field: 'protocolo', label: t('cols.protocolo') },
    ],
    Cell: ({ row }: CellProps<AtendimentoReport>) => (
      <StackedCell primary={row.original.paciente?.nome} secondary={row.original.protocolo} />
    ),
  }),
  // Instituição com o CNPJ como apoio.
  sortableColumn<AtendimentoReport>({
    id: 'paciente.empresa.nomeFantasia',
    hideOnMobile: true,
    useQueryRequest,
    fields: [
      { field: 'paciente.empresa.nomeFantasia', label: t('empresa.label') },
      { field: 'paciente.empresa.cnpj', label: t('cols.documento.cnpj') },
    ],
    Cell: ({ row }: CellProps<AtendimentoReport>) => (
      <StackedCell
        primary={row.original.empresa?.nomeFantasia}
        secondary={row.original.empresa?.cnpj}
      />
    ),
  }),
  // Especialidade com o tipo de atendimento como apoio.
  sortableColumn<AtendimentoReport>({
    id: 'especialidade',
    cellWidth: '200px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [
      { field: 'especialidade', label: t('cols.especialidade') },
      { field: 'tipo', label: t('cols.tipo') },
    ],
    Cell: ({ row }: CellProps<AtendimentoReport>) => (
      <StackedCell
        primary={row.original.especialidade}
        secondary={row.original.tipoAtendimento || row.original.tipo}
      />
    ),
  }),
  sortableColumn<AtendimentoReport>({
    id: 'estado.nome',
    cellWidth: '180px',
    useQueryRequest,
    fields: [{ field: 'estado.nome', label: t('cols.status') }],
    Cell: ({ row }: CellProps<AtendimentoReport>) => (
      <StackedCell primary={row.original.estadoAtendimento} />
    ),
  }),
  sortableColumn<AtendimentoReport>({
    id: 'solicitacao',
    cellWidth: '160px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'solicitacao', label: t('cols.data') }],
    Cell: ({ row }: CellProps<AtendimentoReport>) => (
      <StackedCell tabular primary={row.original.solicitacaoFormatada} />
    ),
  }),
  // Retorno em texto (antes era só um ponto colorido: cor não pode ser o único significado).
  sortableColumn<AtendimentoReport>({
    id: 'retorno',
    cellWidth: '110px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'retorno', label: t('cols.retorno') }],
    Cell: ({ row }: CellProps<AtendimentoReport>) => (
      <StackedCell primary={row.original.retorno ? 'Sim' : 'Não'} />
    ),
  }),
]
